var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('mymask',{attrs:{"loaded":_vm.loaded}}),_vm._v(" "),_c('myheader'),_vm._v(" "),_c('div',{staticClass:"flex-section"},[_c('BrandIntro'),_vm._v(" "),_c('ProductIntro'),_vm._v(" "),_c('flowerList')],1),_vm._v(" "),_c('CardDownload')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b1b532","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Index/index.vue
// module id = 204
// module chunks = 0